export default __webpack_public_path__ + "static/media/witnesses-prosecutor.87ea9ba6.jpg";